import getIn from 'transmute/getIn';
// @ts-expect-error getIn incorrectly yields a result of unknown
export const selectFilterValues = getIn(['findAndFilterData', 'searchAndFilter', 'filterValues', 'data']);